export default {
  /**
   * base64 编码
   * 首先我们使用encodeURIComponent获得百分号编码的UTF-8，然后我们将百分号编码转换为原始字节，这些字节可以被输入到btoa。
   * @param str
   * @returns {string}
   */
  encode: (str: string) =>
    btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) =>
        String.fromCharCode(Number(`0x${p1}`))
      )
    ),

  /**
   * base64 解码
   * 回溯: 从字节流，到百分号编码，再到原始字符串。
   * @param str
   * @returns {string}
   */
  decode: (str: string) =>
    decodeURIComponent(
      atob(str)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    )
};
